/* eslint-disable @typescript-eslint/no-explicit-any */

import { cn } from "@/lib/utils";
import { DocumentTableCell } from "./document-table-cell";
import { Fragment } from "react/jsx-runtime";

export const DocumentTableV3 = ({
  data,
  parentKey,
  keyValue,
  review_required_row_no,
  temp_reviewed,
}: // rowNumber,
any) => {
  const isHide = data?.some((item: any) => item.hide);
  return (
    <div className={cn("float-left test-88888", isHide ? "hidden" : "")}>
      <div
        className={cn(
          "text-[14px] min-w-[200px] w-full  bg-gray-100 font-semibold sticky top-0 z-10 px-3 py-2",
          temp_reviewed ? "h-[46px] flex pt-[3px]" : "h-[46px]",
        )}
      >
        {keyValue}
      </div>
      {data.map((item: any, index: number) => {
        const currentParentKey = parentKey.replace(
          "detailsData.domain_json.",
          "",
        );
        if (item.is_deleted) {
          return null;
        }

        // const currentReviewed = temp_reviewed?.find(
        //   (crItem: any) => crItem.row_number === item.row_number,
        // );

        return (
          <Fragment key={index}>
            <div
              className={cn(
                "w-full ",
                review_required_row_no.includes(item.row_number) /* &&
                  currentReviewed.text === "false" */
                  ? "bg-red-50 test-444"
                  : "odd:bg-gray-50",
              )}
              key={index}
            >
              <DocumentTableCell
                data={item.text}
                key={index}
                keyValue={keyValue}
                parentKey={`${parentKey}.${index}.text`}
                mappingKey={currentParentKey}
                textType="text"
                is_similarity_match={item?.is_similarity_match}
              />
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
